import { Badge } from 'vant'

/**
 * 创建常用功能项的render函数
 * @param {*} img img的src属性
 * @param {*} bg 背景颜色
 */
export function createRenderFunction (img, bg) {
  return function render (h) {
    return h('div', {
      class: 'img-wrap',
      attrs: {
        style: `background: ${bg}`
      }
    }, [
      h('img', {
        attrs: {
          src: img
        }
      })
    ])
  }
}

/**
 * 创建卡片内部项的render函数
 * @param {*} value
 * @param {*} badgeContent
 */
export function createRenderItem (value, badgeContent) {
  return function render (h) {
    return h(badgeContent ? Badge : 'div', {
      props: {
        content: badgeContent,
        color: badgeContent ? '#FF2E2D' : '#0F0F13'
      }
    }, [
      h('span', {
        style: {
          color: badgeContent ? '#FF2E2D' : '#0F0F13'
        }
      }, value)
    ])
  }
}

export const rankLable = [
  { title: 'Today', label: 1 },
  { title: 'This Week', label: 2 },
  { title: 'This Month', label: 3},
]

// 常用功能
export const functionList = [
  {
    label: '淘客',
    value: createRenderFunction(
      require('../../assets/images/icon/icon_taoke@2x.png'),
      'linear-gradient(180deg, #E775F1 0%, #D15DDB 100%);'
    ),
    path: '/taoGuestPool',
    query: '',
    authCode: 'workbench-GuestPool'
  },
  {
    label: 'Long term',
    value: createRenderFunction(
      require('../../assets/images/icon/icon_longterm@2x.png'),
      'linear-gradient(180deg, #B0E775 0%, #99CF5F 100%);'
    ),
    path: '/taoGuestPoolLongTerm',
    query: '',
    authCode: 'workbench-GuestPool'
  },
  {
    label: '订单',
    value: createRenderFunction(
      require('../../assets/images/icon/icon_dingdan@2x.png'),
      'linear-gradient(180deg, #E775F1 0%, #D15DDB 100%);'
    ),
    path: '/orderList',
    query: '',
    authCode: 'order'
  },
  {
    label: '试驾排程',
    value: createRenderFunction(
      require('../../assets/images/icon/icon_shijia@2x.png'),
      'linear-gradient(180deg, #E775F1 0%, #D15DDB 100%);'
    ),
    path: '/testDrive',
    query: '',
    authCode: 'testdrive'
  },
  {
    label: '充电查询',
    value: createRenderFunction(
      require('../../assets/images/icon/icon_chongdian@2x.png'),
      'linear-gradient(180deg, #B077FC 0%, #894FD7 100%);'
    ),
    path: '/chargingSearch',
    query: '',
    authCode: 'workbench-ChargingQuery'
  },
  // {
  //   label: '金融计算器',
  //   value: createRenderFunction(
  //     require('../../assets/images/icon/icon_jisuanqi@2x.png'),
  //     'linear-gradient(180deg, #FFA768 0%, #FA8C3D 100%);'
  //   ),
  //   path: '/financialCalculator',
  //   query: '',
  //   authCode: 'workbench-FinancialCalculator'
  // },
  // {
  //   label: '库存查询',
  //   value: createRenderFunction(
  //     require('../../assets/images/icon/icon_kucun@2x.png'),
  //     'linear-gradient(180deg, #FF7A7A 0%, #F95050 100%);'
  //   ),
  //   path: '/inventory',
  //   query: '',
  //   authCode: 'InventoryList'
  // }
]